import React from "react";
import Dropdown from "react-bootstrap/esm/Dropdown";
import DropdownButton from "react-bootstrap/esm/DropdownButton";

interface VehicleFileValidatorProps {
  label: string;
  validated: boolean;
  enabled: boolean;
  onChangeValidation: (validated: boolean) => void;
}

function VehicleFileValidator({
  label,
  validated,
  enabled,
  onChangeValidation: onValidatedChanged,
}: VehicleFileValidatorProps) {
  if (!enabled) {
    return (
      <i>
        {label} {validated ? "validated" : "not validated"}
      </i>
    );
  }

  const setValidation = (validated: boolean) => {
    onValidatedChanged(validated);
  };

  return (
    <DropdownButton
      title={label + (validated ? " validated" : " not validated")}
      size="sm"
      variant={validated ? "success" : "danger"}
    >
      {validated && (
        <Dropdown.Item onClick={() => setValidation(false)}>
          Remove validation
        </Dropdown.Item>
      )}
      {!validated && (
        <Dropdown.Item onClick={() => setValidation(true)}>
          Validate
        </Dropdown.Item>
      )}
    </DropdownButton>
  );
}

export default VehicleFileValidator;
